/**
 * Converts a byte value to a human-readable string with appropriate unit.
 *
 * Handles string inputs (Google API returns byte values as strings),
 * null/undefined, and invalid values gracefully.
 *
 * @param bytes - The byte value as string, number, null, or undefined
 * @returns Formatted string (e.g., '1.5 GB') or '' for invalid input
 */
export function formatBytes(bytes: string | number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '';

  const numBytes = typeof bytes === 'string' ? Number(bytes) : bytes;
  if (Number.isNaN(numBytes) || numBytes < 0) return '';
  if (numBytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let unitIndex = 0;
  let size = numBytes;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(1)} ${units[unitIndex]}`;
}
